import { CommonGet, CommonPost } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    getGroups,
    getAllOperationEntitiesForDropDown,
    GetEmployeeDetails,
    GetCollectionPointsFilter,
    saveRsmEmployee,
    updateRsmEmployee,
    SaveEmployeeBiometrics,
    getBiometrics,
    RemoveEmployeeBiometrics,
    GetEmployeeTypesData,
    GetEmployeeCategoriesData,
    GetFieldsByCollectionPoint,
    GetEmployeeSubCategoriesData,
    GetCollectionPointsByCpCategoryandOpEntity,
    GetEemployeeDesignationsData,
    GetFeildsByCollectionPointID,
    GetEmployeeRsmFeilds,
    GetRsmEemployeeByID
};


async function GetEmployeeDetails(employeeBiometrics) {
    employeeBiometrics.groupID = employeeBiometrics.groupID.toString();
    employeeBiometrics.operationEntityID = employeeBiometrics.operationEntityID.toString();
    const response = await CommonPost('/api/Employee/FilterRsmEmployee', null, employeeBiometrics);
    return response.data;
}

async function getGroups() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"];
        }
    }
    return groupArray;
}

async function GetFeildsByCollectionPointID(id) {
    var array = [];
    const response = await CommonGet('/api/Field/GetFieldsByCollectionPointID', 'id=' + id);
    for (let item of Object.entries(response.data)) {
        array[item[1]["fieldID"]] = item[1]["fieldName"];
    }
    return array;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function GetCollectionPointsFilter(id) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/Card/GetCollectionPointsFilter', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["operationEntityID"] === parseInt(id))
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function saveRsmEmployee(employeeInformation) {
    employeeInformation.createdBy = parseInt(tokenDecoder.getUserIDFromToken());
    employeeInformation.createdDate = new Date().toISOString();
    const response = await CommonPost('/api/Employee/SaveRsmEmployee', null, employeeInformation);
    return response;
}

async function updateRsmEmployee(employeeInformation) {
    employeeInformation.modifiedBy = parseInt(tokenDecoder.getUserIDFromToken());
    employeeInformation.modifiedDate = new Date().toISOString();
    const response = await CommonPost('/api/Employee/UpdateRsmEmployee', null, employeeInformation);
    return response;
}

async function SaveEmployeeBiometrics(pictures, employeeID) {
    let employeeBiometrics = {
        employeeID: employeeID,
        employeeBiometricData: pictures,
        employeeBiometricDataTypeID: 1,
        isActive: true,
        CreatedBy: 0,
        CreatedDate: new Date().toISOString(),
        modifiedBy: 0,
        ModifiedDate: new Date().toISOString(),
    }
    const response = await CommonPost('/api/EmployeeBiometrics/SaveEmployeeBiometrics', null, employeeBiometrics);
    return response;
}
async function getBiometrics(id, typeId) {
    let filtermodel = {
        employeeID: id,
        employeeBiometricDataTypeID: typeId,

    }
    const response = await CommonPost('/api/EmployeeBiometrics/GetEmployeeBiometricsById', null, filtermodel);

    return response.data;
}
async function RemoveEmployeeBiometrics(id, userId) {
    const response = await CommonGet('/api/EmployeeBiometrics/RemoveEmployeeBiometrics', 'employeeBiometricID=' + id + '&modifiedBy=' + userId);
    return response;
}

async function GetEmployeeTypesData() {
    var response = await CommonGet('/api/EnumData/GetEmployeeTypeEnumData', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}

async function GetEmployeeCategoriesData() {
    var response = await CommonGet('/api/EnumData/GetEmployeeCategoryEnumData', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["key"]] = item[1]["value"]
    }
    return array;
}

async function GetEmployeeSubCategoriesData(employeeCategoryID) {
    var response = await CommonGet('/api/Employee/GetEmployeeSubCategories', 'employeeCategoryID=' + employeeCategoryID);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["collectionPointCategoryID"]] = item[1]["collectionPointTypeName"]
    }
    return array;
}

async function GetFieldsByCollectionPoint(id) {
    var response = await CommonGet('/api/Field/GetFieldsByCollectionPointID', 'id=' + id);
    let array = [];
    for (let item of Object.entries(response.data)) {
        array[item[1]["fieldID"]] = item[1]["fieldName"];
    }
    return array;
}

async function GetCollectionPointsByCpCategoryandOpEntity(operationEntityID, collectionPointCategoryID) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointsByCpCategoryandOpEntity', 'operationEntityID=' + operationEntityID + '&collectionPointCategoryID=' + collectionPointCategoryID);
    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}

async function GetEemployeeDesignationsData(employeeCategoryID) {
    var array = [];
    var response = await CommonGet('/api/Employee/GetEmployeeDesignations', 'employeeCategoryID=' + employeeCategoryID);
    for (let item of Object.entries(response.data)) {
        array[item[1]["designationID"]] = item[1]["designationName"];
    }
    return array;
}

async function GetEmployeeRsmFeilds(employeeID) {
    var response = await CommonGet('/api/EmployeeRsmFeild/GetEmployeeRmsFeilds', 'employeeID=' + employeeID);
    return response.data;
}

async function GetRsmEemployeeByID(id) {
    var response = await CommonGet('/api/Employee/GetRsmEmployeeByID', 'id=' + id);    
    return response.data;
}